/**
 * @description SLA上报
 * @author robbinlei
 * @see atta地址: http://atta.pcg.com/#/dataManage/myData/realData?attaid=03300017626
 * @see 鹰眼地址: http://log2.oa.com/mylog/logQuery/lid/100865
 * @see PCG中台指标：http://paas.woa.com/#/function-manage/sla/428
 */
import { stringify } from './querystring';

const baseReportInfo = {
  attaid: '03300017626',
  token: '8219881712',
};

export enum SlaInitType {
  SUCCESS = 1, // 初始化成功
  FAIL = -1, // 初始化失败
}

export enum Indicators {
  TOTAL = '778', // 进入互动视频
  TIME = '779',  // 互动衔接流畅度耗时
  INIT = 'init', // 初始化
}

export class SLA {
  private businessId: string;

  public constructor(businessId: string) {
    this.businessId = businessId;
  }

  public reportSla(data: { id: string; value: number }) {
    const reportData = {
      ...baseReportInfo,
      ...{
        uid: this.businessId,
        indicators_id: data.id,
        value: data.value,
      },
    };
    if (!PRODUCTION || !this.businessId) {
      return;
    }
    const image = new Image(1, 1);
    image.src = `//h.trace.qq.com/kv?${stringify(reportData).replace(
      /^\?/,
      '',
    )}&_dc=${Math.random()}`;
  }
}
